<template>
  <div class="privacy-container">
    <anchor class="privacy-navigator">
      <anchor-link href="#section1" title="1. 我们如何收集和使用您的个人信息" />
      <anchor-link href="#section2" title="2. 我们如何使用 Cookie 和同类技术" />
      <anchor-link
        href="#section3"
        title="3. 我们如何共享、转让、公开披露您的个人信息"
      />
      <anchor-link href="#section4" title="4. 我们如何保护您的个人信息" />
      <anchor-link href="#section5" title="5. 您的权利" />
      <anchor-link href="#section6" title="6. 我们如何处理儿童的个人信息" />
      <anchor-link href="#section7" title="7. 您的个人信息如何在全球范围转移" />
      <anchor-link href="#section8" title="8. 本政策如何更新" />
      <anchor-link href="#section9" title="9. 如何联系我们" />
      <anchor-link
        href="#section10"
        title="10. 擎天柱Plus APP 接入第三方SDK目录"
      />
    </anchor>
    <privacy-content></privacy-content>
    <footer class="agreeButton">
      <button :class="{ agreeBg: this.agree === 0 }" @click="changeAgree(0)">
        暂不同意
      </button>
      <button :class="{ agreeBg: this.agree === 1 }" @click="changeAgree(1)">
        同意
      </button>
    </footer>
  </div>
</template>

<script>
import anchor from './components/anchor.vue'
import anchorLink from './components/anchorLink.vue'
import privacyContent from './components/privacyContent.vue'

export default {
  components: {
    anchor,
    anchorLink,
    privacyContent
  },
  data() {
    return {
      container: () => document.querySelector('body'),
      agree: 2
    }
  },
  methods: {
    changeAgree(val) {
      this.agree = val
      this.$notify({
        title: '温馨提示',
        type: val === 1 ? 'success' : 'warning',
        message:
          val === 1
            ? '您已同意该隐私政策，请点击左上角返回登录继续操作'
            : '若您不同意该隐私政策，很遗憾我们将无法为您提供服务。'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles/privacy.scss';

.agreeButton {
  position: fixed;
  width: 100%;
  height: 50px;
  z-index: 999;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  button {
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333;
    border: none;
    -webkit-appearance: none;
    outline: none;
    background: #eee;
  }
  button:first-child {
    box-sizing: border-box;
    border-right: 1px solid #999;
  }
  .agreeBg {
    background: lightblue;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/privacyCloud/privacy.vue